import { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import Cookies from 'js-cookie';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookie_consent_agreed');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('cookie_consent_agreed', 'true', { expires: 365 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="cookie-overlay" />
        <div className="cookie-overlay-content">
            <p>
                We use cookies and other tracking technologies to improve your browsing experience on our website. By clicking on accept, you agree to our use of cookies.
            </p>

            <motion.button
                type="button"
                className="col button me-3"
                title="Restart Tour"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.8 }}
                onClick={handleAccept}
            >
                <span className="text">Accept</span>
            </motion.button>
      </div>
    </>
  );
};

export default CookieConsent;
